module.exports = __webpack_public_path__ + "static/media/tama.d62bb232.png";